export const MILLISECONDS_IN_HOUR = 3_600_000;
